// Fetches site-wide SEO settings (defaults, analytics IDs, verification,
// sitemap config, robots.txt source, organization JSON-LD).
// Cached in-memory across the app to avoid duplicate requests.
import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let cache = null;
let inflight = null;

export default function useSiteSEO() {
  const [data, setData] = useState(cache);
  const [loaded, setLoaded] = useState(!!cache);

  useEffect(() => {
    if (cache) {
      setData(cache);
      setLoaded(true);
      return undefined;
    }
    let alive = true;
    if (!inflight) {
      inflight = axios.get(`${BACKEND_URL}/api/site-settings/site-seo`).then((r) => r.data).catch(() => ({}));
    }
    inflight.then((d) => {
      cache = d || {};
      if (alive) {
        setData(cache);
        setLoaded(true);
      }
    });
    return () => { alive = false; };
  }, []);

  return { data: data || {}, loaded };
}

export function clearSiteSEOCache() {
  cache = null;
  inflight = null;
}
